import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {DeclarationType} from "@portbase/bezoekschip-service-typescriptmodels";
import {EmergencySummaryExpanded} from "../emergency-overview-item.component";
import {EmergencyOverviewUtils} from "../../emergency-overview.utils";
import {DeclarationMessageStatus} from "../../../visit-overview/visit-overview-item/visit-overview.utils";
import {ClearanceService} from "../../../../visit-details/visit/clearance/clearance-service";

/**
 * Dedicated emergency-procedure (EP) status indicator for the "other services" cell of an EP row.
 *
 * WHY a dedicated component instead of reusing app-visit-overview-service-status: the visit
 * component derives its statuses through VisitOverviewUtils, whose VISIT gate short-circuits on the
 * permanently-PENDING agent-side task status before it ever consults the EKH clearance. In the
 * emergency procedure the harbour master works via clearances and never sends a technical VISIT
 * declaration response, so that task status stays PENDING forever and the dot must reflect the EKH
 * clearance instead. This component therefore derives via EmergencyOverviewUtils.getTaskStatuses
 * (the EP-specific gate) and delegates all rendering to the shared dumb app-status-indicator.
 *
 * It is a thin wrapper: EP derivation + delegation. It intentionally carries none of the visit-only
 * concepts (orderStatus, bunkering, inspection, harbourDues).
 */
@Component({
  selector: 'app-emergency-overview-service-status',
  templateUrl: './emergency-overview-service-status.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmergencyOverviewServiceStatusComponent {
  _summary: EmergencySummaryExpanded;
  _declarationTypes: DeclarationType[];
  _statusIndicatorButtonId: string;
  _statusIndicatorSpanId: string;
  messageStatuses: DeclarationMessageStatus[] = [];

  constructor(protected clearanceService: ClearanceService) {
  }

  @Input()
  set summary(summary: EmergencySummaryExpanded) {
    this._summary = summary;
    this.updateMessageStatuses();
  }

  @Input()
  set declarationTypes(declarationTypes: DeclarationType[]) {
    this._declarationTypes = declarationTypes;
    this.updateMessageStatuses();
  }

  @Input()
  set statusIndicatorButtonId(statusIndicatorButtonId: string) {
    this._statusIndicatorButtonId = statusIndicatorButtonId;
  }

  @Input()
  set statusIndicatorSpanId(statusIndicatorSpanId: string) {
    this._statusIndicatorSpanId = statusIndicatorSpanId;
  }

  private updateMessageStatuses() {
    this.messageStatuses = this._summary && this._declarationTypes
      ? EmergencyOverviewUtils.getTaskStatuses(this._summary, this._declarationTypes, this.clearanceService)
      : [];
  }
}
